import { Component, HostListener } from '@angular/core';
import { CampaignModel } from 'src/app/models/campaigns.model';
import { MonitoringService } from 'src/app/services/monitoring.service';
import { RellenoService } from 'src/app/services/relleno.service';
import { RellenoMaterialComponent } from '../shared/dialogs/relleno-material/relleno-material.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RellenoMovInvComponent } from '../shared/dialogs/relleno-mov-inv/relleno-mov-inv.component';
import Swal from 'sweetalert2';
import { ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { RellenoHistorialComponent } from '../shared/dialogs/relleno-historial/relleno-historial.component';
import { RellenoScanMaterialComponent } from '../shared/dialogs/relleno-scan-material/relleno-scan-material.component';

interface GridMatItem {
  id: number;
  nombre_mat?: string;
  row: number;
  col: number;
  cantidad: number;
  cantidad_total: number;
  line: number;
  estacion: string;
  sku: string;
  actual: number;
  img: string;
  peso: number;
  batch: number;
  empacado: number;
  bitPesoUnitario: boolean;
  bitTamanoBatch: boolean;
  id_rack_material: number;
  limite_minimo: number;
  color: string;
  color2: string;
  id_mat_camp: string;
  en_linea: number;
}

@Component({
  selector: 'app-relleno',
  templateUrl: './relleno.component.html',
  styleUrls: ['./relleno.component.scss']
})
export class RellenoComponent {

  isLoadingGeneral = true;
  campaignSelected?: CampaignModel;
  campaignList = new Array<CampaignModel>();
  compania = '';
  fecha_inicio =  '';
  fecha_fin = '';
  lineas: {line: number, estaciones: number, alertas: number, color: string, colorBorde: string}[] = [];
  objLineasEstaciones: any[] = [];
  datosLineas: {nombre: string, line: number, color: string, colorBorde: string}[] = [];
  lineaSeleccionadaId: number = 0;
  estacionSeleccionada: string = '';

  selectedLinea: boolean = false;
  selectedEstacion: boolean = false;
  lineasEstaciones = [];
  filas_materiales: number = 0;
  columnas_materiales: number = 0;
  objLineaEstacionSelected: {filas: number, columnas: number}[] = [];
  grid_mat: GridMatItem[] = [];
  new_grid_mat: GridMatItem[] = [];

  objEstaciones: {estacion: string, line: number, cantidad_total: number, alertas: number, cant_mat: number, comparte: string}[] = [];
  objMateriales: {nombre_mat: string, sku: string, cantidad: number, cantidad_total: number, actual: number, alertas: number}[] = [];
  code: string = "";
  tipo_estacion: string = "";

  constructor(
    private monitoringServ: MonitoringService,
    private rellenoService: RellenoService,
    private matDialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getCampaignList();
  }

  //Obtener campaigns para el select
  getCampaignList() {
    this.monitoringServ.getCampaingsMonitoringList().subscribe(
      (result: any) => {
        this.campaignList = result;
        this.setCampaignData(this.campaignList[0]);
      },
      (err: any) => {
        console.log(err);
        this.isLoadingGeneral = false;
      }
    );
  }

  setCampaignData(campaign: any) {
    this.isLoadingGeneral = true;
    this.campaignSelected = campaign;
    this.getGeneralData(campaign);
    this.getLineasEstaciones(campaign,0,0);
    this.selectedLinea = false;
    this.selectedEstacion = false;
    this.lineaSeleccionadaId = 0;
    this.estacionSeleccionada = '';
    this.code = ''; 
  }

  getGeneralData(campaign: any) {

    this.monitoringServ.getGeneralData(campaign.id).subscribe(
      (result: any) => {

        //Encabezado
        this.compania = result.campaignData[0][0].clave;

        if (result.campaignData[0][0].fecha_inicio != null) {
          const fechaOriginal1 = new Date(result.campaignData[0][0].fecha_inicio);
          const fechaAjustada1 = new Date(fechaOriginal1.getTime() + (6 * 60 * 60 * 1000)); // Ajusta según zona horaria
          this.fecha_inicio = fechaAjustada1.toISOString().split('T')[0];
        }
        else {
          this.fecha_inicio = '';
        }

        if (result.campaignData[0][0].fecha_fin != null) {
          const fechaOriginal2 = new Date(result.campaignData[0][0].fecha_fin);
          const fechaAjustada2 = new Date(fechaOriginal2.getTime() + (6 * 60 * 60 * 1000)); // Ajusta según zona horaria
          this.fecha_fin = fechaAjustada2.toISOString().split('T')[0];
        }
        else {
          this.fecha_fin = '';
        }
        this.isLoadingGeneral = false;

      },
      (err: any) => {
        console.log(err);
        this.isLoadingGeneral = false;
      }
    );

  }

  getLineasEstaciones(campaign: any, type: number, line_selected: number) {

    this.rellenoService.getLineasEstacionesData(campaign.id).subscribe(
      (result: any) => {

        this.lineas = result.lineas;
        this.objLineasEstaciones = result.data;
        this.lineasEstaciones = result.lineasEstaciones;
        this.objEstaciones = result.objEstaciones;
        this.objMateriales = result.objMateriales;

        if (this.objLineasEstaciones != undefined) {

          //Poner color a las cards de lineas y estaciones

          //Colores a estaciones
          this.lineasEstaciones.map((item: any) => {

            if(item.materiales != null){
              let materiales_est = JSON.parse(item.materiales);

              const newMaterials = materiales_est.map((mat_e: any) => {
                const search_mat = this.objLineasEstaciones.find((obj: any) => obj.id_mat == mat_e.id && obj.estacion == item.nombre && obj.line == item.line);

                if (search_mat) {

                  if (search_mat.empacado >= search_mat.cantidad_total) {
                    mat_e.nombreColor = 'Blanco'
                  }
                  else if (search_mat.cantidad == 0) {
                    mat_e.nombreColor = 'Rojo'
                  }
                  else if (search_mat.cantidad > 0 && search_mat.cantidad < search_mat.limite_minimo) {
                    mat_e.nombreColor = 'Amarillo'
                  }
                  else if (search_mat.cantidad >= search_mat.limite_minimo) {
                    mat_e.nombreColor = 'Verde'
                  }
                }

                return mat_e;
              })
              item.newMaterials = newMaterials;
            }
            //Si es estacion de bolsas
            else{
              const search_mat = this.objLineasEstaciones.filter((obj: any) => obj.estacion == item.nombre);
              let nombreColor = '';

              const obj_mat = search_mat.map((item_s:any) => {
                nombreColor = '';
                if (item_s.empacado >= item_s.cantidad_total) {
                    nombreColor = 'Blanco'
                  }
                  else if (item_s.cantidad == 0) {
                    nombreColor = 'Rojo'
                  }
                  else if (item_s.cantidad > 0 && item_s.cantidad < item_s.limite_minimo) {
                    nombreColor = 'Amarillo'
                  }
                  else if (item_s.cantidad >= item_s.limite_minimo) {
                    nombreColor = 'Verde'
                  }
                  return {
                    nombreColor: nombreColor
                  };
              })

              item.newMaterials = obj_mat;
            
            }

          })

          this.lineasEstaciones.map( (dl:any) => {
              let contRojos = dl.newMaterials.filter( (col:any) => col.nombreColor == 'Rojo');
              let contAmarillos = dl.newMaterials.filter( (col:any) => col.nombreColor == 'Amarillo');
              let contBlancos = dl.newMaterials.filter( (col:any) => col.nombreColor == 'Blanco');
              let contVerdes = dl.newMaterials.filter( (col:any) => col.nombreColor == 'Verde');

            if(contBlancos.length == dl.newMaterials.length){
              dl.color = '#ffffff';
              dl.colorBorde = '#ffffff';
              dl.colorNombre = 'blanco'; 
            }
            else if(contRojos.length > 0){
              dl.color = '#FED3C8';
              dl.colorBorde = '#ff9075ff';
              dl.colorNombre = 'rojo'; 
            }
            else if(contAmarillos.length > 0 && contVerdes.length > 0){
              dl.color = '#FEE9B8';
              dl.colorBorde = '#f7cc69ff';
              dl.colorNombre = 'amarillo'; 
            }
            else if(contVerdes.length > 0 && contAmarillos.length == 0 && contRojos.length == 0){
              dl.color = '#C9EECC';
              dl.colorBorde = '#72df7bff';
              dl.colorNombre = 'verde'; 
            }
              
          })

          //Color a lineas
          this.lineas.map((item: any) => {
            
            let est_rojo = 0;
            let est_amarillo = 0;
            let est_verde = 0;
            let est_blanco = 0;

            this.lineasEstaciones.filter( (le:any) => le.line == item.line).map( (el:any) => {
              if(el.colorNombre == 'rojo'){
                est_rojo++;
              }
              else if(el.colorNombre == 'amarillo'){
                est_amarillo++;
              }
              else if(el.colorNombre == 'blanco'){
                est_blanco++;
              }
              else{
                est_verde++
              }
            });

            if (est_rojo > 0) {
              item.color = '#FED3C8';
              item.colorBorde = '#ff9075ff';
            }
            else if ((est_amarillo > 0) && (est_rojo == 0)) {
              item.color = '#FEE9B8';
              item.colorBorde = '#f7cc69ff';
            }
            else if(((est_amarillo == 0) && (est_verde > 0))){
              item.color = '#C9EECC';
              item.colorBorde = '#72df7bff';
            }
            else {
              item.color = '#ffffff';
              item.colorBorde = '#ffffff';
            }
          })
        }


        //Cuando se guarde un relleno de material o se mueva inventario o haga reload
        if(type == 1){
          const est_ant = this.estacionSeleccionada;
          this.seleccionarLinea(line_selected);
          if(est_ant != ''){
            const estacion = this.lineasEstaciones.find((item:any) => item.line == line_selected && item.nombre == est_ant)
            this.seleccionarEstacion(estacion)
          }
        }

        this.isLoadingGeneral = false;


      },
      (err: any) => {
        console.log(err);
        this.isLoadingGeneral = false;
      }
    );

  }

  seleccionarLinea(line: number) {
    
    this.estacionSeleccionada = '';

    this.lineaSeleccionadaId = line;
    this.selectedLinea = true;
    this.selectedEstacion = false;
    this.datosLineas = this.lineasEstaciones.filter((item:any) => item.line == line )  
  }

  seleccionarEstacion(objLineaEstacion: any) {

    this.estacionSeleccionada = objLineaEstacion.nombre;
    this.selectedEstacion = true;
    this.objLineaEstacionSelected = objLineaEstacion;

    this.tipo_estacion = objLineaEstacion.tipo;    

    if(this.tipo_estacion != "BG"){

      let materiales_rack = JSON.parse(objLineaEstacion.materiales);

      this.filas_materiales = objLineaEstacion.filas;
      this.columnas_materiales = objLineaEstacion.columnas;

      this.grid_mat = [];
      for (let f = 1; f <= this.filas_materiales; f++) {
        for (let c = 1; c <= this.columnas_materiales; c++) {
          let obj_m = materiales_rack.find((m:any)=>m.row==f&&m.col==c);
          if(!obj_m) {
            obj_m = {row: f, col: c}
          }
          this.grid_mat.push(obj_m);
        }
      }

      this.grid_mat.map( (item:GridMatItem) => {

        let search_mat;

        if(objLineaEstacion.nombre_comparte != null){
          search_mat = this.objLineasEstaciones.find((obj:any)=>obj.id_mat==item.id && obj.estacion==objLineaEstacion.nombre_comparte && obj.line == objLineaEstacion.linea_comparte);
        } 
        else{
          search_mat = this.objLineasEstaciones.find((obj:any)=>obj.id_mat==item.id && obj.estacion==objLineaEstacion.nombre && obj.line == objLineaEstacion.line);
        }
        
        if(search_mat){
          item.nombre_mat = search_mat.nombre_mat;
          item.cantidad = search_mat.cantidad;
          item.cantidad_total = search_mat.cantidad_total;
          item.line = search_mat.line;
          item.estacion = search_mat.estacion;
          item.sku = search_mat.sku;
          item.actual = search_mat.actual;
          item.img = search_mat.img;
          item.peso = search_mat.peso;
          item.batch = search_mat.batch;
          item.empacado = search_mat.empacado;
          item.bitPesoUnitario = search_mat.bitPesoUnitario;
          item.bitTamanoBatch = search_mat.bitTamanoBatch;
          item.id_rack_material = search_mat.id_rack_material;
          item.limite_minimo = search_mat.limite_minimo;
          item.id_mat_camp = search_mat.id_mat_camp;
          item.en_linea = search_mat.en_linea;

          /* if(item.cantidad == 0){
            item.color = '#FED3C8';
            item.color2 = '#FDA994';
          }
          else if(item.cantidad <= item.limite_minimo){
            item.color = '#FEE9B8';
            item.color2 = '#FED67C';
          }
          else{
            item.color = '#C9EECC';
            item.color2 = '#75D17A';
          } */

            if(item.empacado >= item.cantidad_total){
              item.color = '#FFFFFF';
              item.color2 = '#f3f3f3';
            }
            else if(item.cantidad == 0){
              item.color = '#FED3C8';
              item.color2 = '#FDA994';
            }
            else if(item.cantidad > 0 && item.cantidad < item.limite_minimo){
              item.color = '#FEE9B8';
              item.color2 = '#FED67C';
            }
            else if(item.cantidad >= item.limite_minimo){
              item.color = '#C9EECC';
              item.color2 = '#75D17A';
            }
            
            
        }
        return item;
      });
    }

    else{
      this.grid_mat = [];

      const search_mat = this.objLineasEstaciones.filter((obj:any)=>obj.estacion==this.estacionSeleccionada);

      search_mat.map((item:any) => {
        item.id = 1;
            if(item.empacado >= item.cantidad_total){
              item.color = '#FFFFFF';
              item.color2 = '#f3f3f3';
            }
            else if(item.cantidad == 0){
              item.color = '#FED3C8';
              item.color2 = '#FDA994';
            }
            else if(item.cantidad > 0 && item.cantidad < item.limite_minimo){
              item.color = '#FEE9B8';
              item.color2 = '#FED67C';
            }
            else{
              item.color = '#C9EECC';
              item.color2 = '#75D17A';
            }
            
      })

      this.grid_mat = search_mat;

    }
    
    

  }

  openRellenoMaterial(row: any, tipo: string){

    let camp = this.campaignSelected;
    let est_sel = this.estacionSeleccionada;
    
    if(row.id){
      this.matDialog.open(RellenoMaterialComponent, {
      panelClass: ['dialogs-md'],
      data: {
        ...row,
        tipo,
        camp
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          this.getLineasEstaciones(this.campaignSelected, 1, this.lineaSeleccionadaId);
          //this.seleccionarLinea(this.lineaSeleccionadaId);
          /* this.estacionSeleccionada = est_sel;

          const estac_selec = this.datosLineas.find((item:any) => item.nombre == this.estacionSeleccionada);
          this.seleccionarEstacion(estac_selec); */
        }
        this.code = '';    
      }
    );
    }
    
  }

  movInventario(row:any){
    this.matDialog.open(RellenoMovInvComponent, {
      panelClass: ['dialogs-main'],
      data: {
        ...row,
        dataObj: this.objLineasEstaciones,
        lineas: this.lineas,
        datosLineas: this.datosLineas,
        objEstaciones: this.objEstaciones
      } 
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          this.getLineasEstaciones(this.campaignSelected,1,this.lineaSeleccionadaId);
        }
        this.code = '';    
      }
    );
  }

  @HostListener('window:keypress', ['$event'])
  keyEvent(event: KeyboardEvent): void {

     if (event.key === 'Enter') {
      this.procesarScan(this.code);
     }
     else {
      this.code += event.key;
     }
  }

  procesarScan(codigo: string): void {
    const scan = codigo.trim();
    const estacionEncontrada = this.objEstaciones.find((estacionObj) => estacionObj.estacion === scan);
    const materialEncontrado = this.objLineasEstaciones.filter((material) => material.sku === scan);
    this.matDialog.closeAll();

    //Cuando escanee una estacion
    if (estacionEncontrada) {
      const estacion = this.lineasEstaciones.find((item:any) => item.line == estacionEncontrada.line && item.nombre == estacionEncontrada.estacion)
      this.selectedLinea = true;

      this.seleccionarLinea(estacionEncontrada.line)
      this.seleccionarEstacion(estacion)

    } 
    //Cuando escanee un sku
    else if(materialEncontrado.length > 0){
      let lineas = this.lineas;
      
      this.matDialog.open(RellenoScanMaterialComponent, {
        panelClass: ['dialogs-md'],
        data: {
          materialEncontrado,
          lineas,
          scan,
          datosLineas: this.lineasEstaciones,
          campaign: this.campaignSelected
        }
      }).afterClosed().subscribe(
        resp => {
          this.code = '';
        }
      );
    }
    else {      
      Swal.fire({
        icon: 'error',
        title: 'Estación o material no encontrado',
        text: `${scan}`,
        timer: 3000
      });
    }
    
    this.code = '';    
  }

  openModalHistory(){
    let dataCampaign = this.campaignSelected;
    this.matDialog.open(RellenoHistorialComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        dataCampaign
      } 
    }).afterClosed().subscribe(
      resp => {
    
      }
    );
  }

  reloadData(){
    const campaign = this.campaignSelected;
    if (!campaign) {
      return;
    }
    this.isLoadingGeneral = true;
    const selectedLine = this.lineaSeleccionadaId;
    this.getLineasEstaciones(campaign, selectedLine !== 0 ? 1 : 0, selectedLine);
  }

}
